import React from 'react';
import { Card, Col, Flex, Row, Spin, theme } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

import ButtonWithRole from '../../../components/ButtonWithRole';
import { BILLING_WRITE_REFUSED_ROLES } from '../../auth/roleCapabilities';
import { useSubscriptionState } from '../PlanStatus';
import { usePaymentChargebeeInfo } from '../hooks/usePaymentChargebeeInfo';

const BillingPayment = () => {
  const { token } = theme.useToken();
  const { onChangeBillingAddress, onChangePaymentMethod } = usePaymentChargebeeInfo();
  const [_, paymentMethodState] = useSubscriptionState();
  const cardStyle = { marginBottom: token.marginLG };
  const cardTitleStyle = { marginBottom: token.marginXS };

  return (
    <>
      <h3>Payment Settings</h3>
      <p style={{ color: token.colorTextSecondary }}>Update your billing details below.</p>
      <Row gutter={12}>
        <Col xs={24} lg={12}>
          <Card variant="borderless" style={cardStyle}>
            <Flex justify="space-between" align="center">
              <h5 style={cardTitleStyle}>Billing Address</h5>
              {!paymentMethodState.isLoading && (
                <>
                  {!paymentMethodState.isAddressValid ? (
                    <ExclamationCircleOutlined style={{ color: token.colorError }} />
                  ) : (
                    <CheckCircleOutlined style={{ color: token.colorSuccess }} />
                  )}
                </>
              )}
              {paymentMethodState.isLoading ? <Spin /> : null}
            </Flex>
            {!paymentMethodState.isLoading && (
              <p>
                {!paymentMethodState.isAddressValid ? 'Please add your billing address.' : 'A billing address is set.'}
              </p>
            )}

            {!paymentMethodState.isLoading && (
              <>
                <hr />
                <ButtonWithRole disabledFor={BILLING_WRITE_REFUSED_ROLES} onClick={onChangeBillingAddress} block>
                  {!paymentMethodState.isAddressValid ? 'Add' : 'Change'}
                </ButtonWithRole>
              </>
            )}
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card variant="borderless" style={cardStyle}>
            <Flex justify="space-between" align="center">
              <h5 style={cardTitleStyle}>Payment Method</h5>
              {!paymentMethodState.isLoading && (
                <>
                  {!paymentMethodState.isCreditCardValid ? (
                    <ExclamationCircleOutlined style={{ color: token.colorError }} />
                  ) : (
                    <CheckCircleOutlined style={{ color: token.colorSuccess }} />
                  )}
                </>
              )}
              {paymentMethodState.isLoading ? <Spin /> : null}
            </Flex>
            {!paymentMethodState.isLoading && (
              <p>
                {!paymentMethodState.isPaymentMethodSet && 'Please add your preferred payment method.'}

                {paymentMethodState.isPaymentMethodSet &&
                  (paymentMethodState.isCreditCardValid
                    ? 'A payment method is set.'
                    : 'Your payment method is invalid, please check your card details.')}
              </p>
            )}
            {!paymentMethodState.isLoading && (
              <>
                <hr />
                <ButtonWithRole disabledFor={BILLING_WRITE_REFUSED_ROLES} onClick={onChangePaymentMethod} block>
                  {!paymentMethodState.isPaymentMethodSet ? 'Add' : 'Change'}
                </ButtonWithRole>
              </>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default BillingPayment;
